import React from "react";
import { ExternalLink, Link as LinkIcon } from "lucide-react";
import TiltCard from "../components/TiltCard";
import PageBanner, { SectionTitle } from "../components/PageBanner";
import { usefulLinks, pageBanners } from "../data/mock";

export default function UsefulLinks() {
  return (
    <div className="page-enter">
      <PageBanner image={pageBanners.links} title="Useful Links" subtitle="Quick access to affiliated departments, regulators, and health-education portals." />

      <section style={{ padding: "50px 24px 60px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionTitle>Resources &amp; Portals</SectionTitle>
          <div className="grid-eq grid-4" style={{ display: "grid", gap: 20 }} data-testid="useful-links-grid">
          {usefulLinks.map((l, i) => (
            <a key={i} href={l.url} target="_blank" rel="noreferrer" data-testid={`useful-link-${i}`} style={{ textDecoration: "none" }}>
              <TiltCard intensity={5}>
                <div style={{ padding: 24 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div className={`icon-tile ${i % 3 === 1 ? "icon-tile-yellow" : i % 3 === 2 ? "icon-tile-red" : ""}`}>
                      <LinkIcon size={20} />
                    </div>
                    <ExternalLink size={16} color="#EA580C" />
                  </div>
                  <h3 className="font-serif" style={{ fontSize: 17, color: "#1C1917", fontWeight: 700, marginTop: 14 }}>{l.name}</h3>
                  <p style={{ color: "#44403C", fontSize: 13, lineHeight: 1.6, marginTop: 6 }}>{l.desc}</p>
                </div>
              </TiltCard>
            </a>
          ))}
          </div>
        </div>
      </section>
    </div>
  );
}
